export abstract class Command<TResult = void> {
    private t_result!: TResult;
}
